<template>
  <component :is="tagType" v-if="!isBoolean" :class="styleClass" v-html="display"/>
  <component :is="tagType" v-else :class="styleClass">
    <v-icon class="fa-table-icon">{{ value ? 'far fa-check-square' : 'far fa-square' }}</v-icon>
    <span v-if="value" class="sr-only">{{ $t('global.yes') }}</span>
    <span v-else class="sr-only">{{ $t('global.no') }}</span>
  </component>
</template>

<script>
import { format, getHeaderAlignmentClass } from '@/support/ui';
import isArray from 'lodash/isArray';
import each from 'lodash/each';
import escape from 'lodash/escape';

export default {
  props: {
    dataType: {
      type: String,
      required: true
    },
    value: {
      type: null, // accepts anything
      required: true
    },
    tagType: {
      type: String,
      required: true
    }
  },
  computed: {
    isBoolean () {
      return this.dataType === this.$PACONST.DISPLAY_TYPE_BOOLEAN;
    },
    display () {
      let display = '';
      if (this.dataType === this.$PACONST.DISPLAY_TYPE_STRING) {
        if (isArray(this.value)) {
          each(this.value, (value, i, list) => {
            display += this.escapeAndMatch(value);
            if (i !== (list.length - 1)) {
              display += '<br>';
            }
          });
        }
        else {
          display = this.escapeAndMatch(this.value);
        }
      }
      else if (this.dataType === this.$PACONST.DISPLAY_TYPE_NUMBER ||
        this.dataType === this.$PACONST.DISPLAY_TYPE_DATE ||
        this.dataType === this.$PACONST.DISPLAY_TYPE_DATETIME ||
        this.dataType === this.$PACONST.DISPLAY_TYPE_MONEY ||
        this.dataType === this.$PACONST.DISPLAY_TYPE_PERCENT ||
        this.dataType === this.$PACONST.DISPLAY_TYPE_DECIMAL) {
        display = format(this.value, this.dataType);
      }

      return display;
    },
    styleClass () {
      return getHeaderAlignmentClass(this.dataType);
    }
  },
  methods: {
    // HTML escapes the specified string and also looks for and preserves any full text highlighting matches
    escapeAndMatch (value) {
      let temp = '';

      if (value !== undefined && value !== null)
      {
        temp = value.replace(/<em>/g, '@em@').replace(/<\/em>/g, '@/em@');
        temp = escape(temp);
        temp = temp.replace(/@em@/g, '<span class="pa-full-text-match">').replace(/@\/em@/g, '</span>');
      }

      return temp;
    }
  }
};
</script>
